import { useState } from "react";
import { adaptToGdoc } from "../../api/GPT";
import FileUploaderNBK from "../shared/components/FileUploader";

import "../../App.css";
import { useNavigate } from "react-router-dom";
import Takoyaki from "../shared/components/TakoyakiIcon";
import { Button } from "antd";

const GPTToGdoc = () => {
  const navigate = useNavigate();

  const [gDocId, setGDocId] = useState("");
  const [codeSerie, setCodeSerie] = useState("");
  const [file, setFile] = useState(null);
  const [storeType] = useState("gdoc");

  const [isLoading, setIsLoading] = useState(false);

  const onFileDrop = (file) => {
    console.log(file);
    setFile(file);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      console.log("on submit");
      if (file === null) return;
      if (storeType === "gdoc" && gDocId.length <= 0) return;

      setIsLoading(true);

      const keys = Object.keys(file);
      for (let k = 0; k < keys.length; k++) {
        const key = keys[k];
        const f = file[key];
        console.log(f);

        const formData = new FormData();

        formData.append("txtFile", f);
        formData.append("storeType", storeType);
        formData.append("codeSerie", codeSerie);
        formData.append("epNumber", k);

        if (storeType === "gdoc") formData.append("gDocId", gDocId);

        const res = await adaptToGdoc(formData);
        console.log("ADAPT FILE :", res);
        if (res.uid) navigate(`/doc/${res.uid}`);
      }
      setIsLoading(false);
    } catch (error) {
      // Consider implementing your own error handling logic here
      console.error(error);
      alert(error.message);
    }
  };

  const gDocInput = () => {
    return (
      <>
        <label>Google directory ID</label>
        <input
          type="text"
          name="gDocId"
          placeholder="1ing8W1rDHFo8mKDkkE96_VOsP21ENhXW"
          value={gDocId}
          onChange={(e) => setGDocId(e.target.value)}
          contentEditable={!isLoading}
        />
      </>
    );
  };

  return (
    <div>
      <main className="main">
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Takoyaki style={{ marginRight: 10 }} />
          <h1>TakoIAki</h1>
        </div>
        <form onSubmit={onSubmit}>
          <FileUploaderNBK onFileDrop={onFileDrop} file={file} />
          <label>Code Série</label>
          <input
            type="text"
            name="serieCode"
            value={codeSerie}
            onChange={(e) => setCodeSerie(e.target.value)}
            contentEditable={!isLoading}
          />
          {gDocInput()}
          <input
            disabled={isLoading}
            type="submit"
            value={isLoading ? "Chargement..." : "Adapter le texte"}
          />
        </form>
        <Button onClick={() => navigate(-1)}>Revenir en arrière</Button>
      </main>
    </div>
  );
};

export default GPTToGdoc;
